import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const rombes = document.querySelectorAll('.rombe');

if (rombes.length) {
	gsap.registerPlugin(ScrollTrigger);

	rombes.forEach(rombe => {
		const paths = gsap.utils.toArray(rombe.querySelectorAll('path'));

		gsap.to(paths, {
			opacity: 1,
			duration: 0.3,
			stagger: 0.1,
			ease: 'power2.inOut',
			scrollTrigger: {
				trigger: rombe.parentElement.parentElement,
				start: 'top center',
				end: 'bottom center',
				toggleActions: 'play reverse play reverse',
				markers: false,
			},
		});
	});
}
